<template>
  <div class="evaluation">
    <div class="banner-wrapper">
      <img src="../assets/service/banner3.png" alt="" class="banner">
    </div>
    <div class="resources-list">
      <div class="list" v-for="(item,index) in list" :key="index">
        <h3 class="list-title flex-align-between">
          <p><img :src="item.titleIcon" class="title-icon">{{item.title}}</p>
          <button class="more csp">更多<i class="el-icon-arrow-right" style="font-size:14px"></i></button>
        </h3>
        <!-- class="flex-layout" style="flex-flow: row wrap;" -->
        <ul>
          <li v-for="(each,i) in item.resources" :key="each.id" class="list-li">
            <div class="list-li-wrapper flex-layout">
              <img :src="require(`../assets/service/${i+1}.png`)" alt="" style="height:100%" :onerror="defaultCover">
              <div class="list-li-info">
                <h4 class="info-name">{{each.name}}</h4>
                <el-rate v-model="each.score" disabled :colors="['#FFC600', '#FFC600', '#FFC600']">
                </el-rate>
                <!-- <p class="info-usedTimes">共使用{{each.usedTime}}次</p> -->
                <button class="enter csp" v-if="each.canView != 0" @click="enter(each)">进入<i class="el-icon-arrow-right"
                    style="font-size:14px;vertical-align:middle"></i></button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Login></Login>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        defaultCover: `this.src="${require("../assets/service/01.png")}"`,
        list: [{
          title: '中高考进阶学习',
          titleIcon: require("../assets/service/title-icon1.png"),
          resources: [{
              "id": 19,
              "name": "测试",
              "code": null,
              "url": "sssssssssssssssss",
              "userKey": null,
              "secretKey": null,
              "isCourseThird": 0,
              "showParams": null,
              "mark": 101,
              "markName": "综合素质评价",
              "coverUrl": null,
              "score": null,
              "page": null,
              "limit": null,
              "canView": 2
            },
            {
              "id": 24,
              "name": "liup1122",
              "code": null,
              "url": "https://qrlogin.hexfuture.net/index.html?clienttype=16",
              "userKey": null,
              "secretKey": null,
              "isCourseThird": 1,
              "showParams": null,
              "mark": 101,
              "markName": "综合素质评价",
              "coverUrl": null,
              "score": null,
              "page": null,
              "limit": null,
              "canView": 2
            },
            {
              "id": 5,
              "name": "继教网_14师",
              "code": null,
              "url": "http://QR20201100602.stu.t-px.cn/capitalEducation/personCultureAuth?item=1",
              "userKey": null,
              "secretKey": null,
              "isCourseThird": 1,
              "showParams": null,
              "mark": 100,
              "markName": "中高考进阶学习",
              "coverUrl": null,
              "score": null,
              "page": null,
              "limit": null,
              "canView": 2
            },
            {
              "id": 23,
              "name": "课程帮",
              "code": null,
              "url": "https://www.kcbxgk.com/sso/cnuen/login?item=1",
              "userKey": null,
              "secretKey": null,
              "isCourseThird": 1,
              "showParams": null,
              "mark": 100,
              "markName": "中高考进阶学习",
              "coverUrl": null,
              "score": null,
              "page": null,
              "limit": null,
              "canView": 2
            },
            {
              "id": 28,
              "name": "ddd",
              "code": null,
              "url": "ddd",
              "userKey": null,
              "secretKey": null,
              "isCourseThird": 0,
              "showParams": null,
              "mark": 100,
              "markName": "中高考进阶学习",
              "coverUrl": null,
              "score": null,
              "page": null,
              "limit": null,
              "canView": 2
            }
          ]
        }],
        resources: [{
            "id": 19,
            "name": "测试",
            "code": null,
            "url": "sssssssssssssssss",
            "userKey": null,
            "secretKey": null,
            "isCourseThird": 0,
            "showParams": null,
            "mark": 101,
            "markName": "综合素质评价",
            "coverUrl": null,
            "score": null,
            "page": null,
            "limit": null,
            "canView": 2
          },
          {
            "id": 24,
            "name": "liup1122",
            "code": null,
            "url": "https://qrlogin.hexfuture.net/index.html?clienttype=16",
            "userKey": null,
            "secretKey": null,
            "isCourseThird": 1,
            "showParams": null,
            "mark": 101,
            "markName": "综合素质评价",
            "coverUrl": null,
            "score": 1,
            "page": null,
            "limit": null,
            "canView": 2
          },
          {
            "id": 5,
            "name": "继教网_14师",
            "code": null,
            "url": "http://QR20201100602.stu.t-px.cn/capitalEducation/personCultureAuth?item=1",
            "userKey": null,
            "secretKey": null,
            "isCourseThird": 1,
            "showParams": null,
            "mark": 100,
            "markName": "中高考进阶学习",
            "coverUrl": null,
            "score": 3,
            "page": null,
            "limit": null,
            "canView": 2
          },
          {
            "id": 23,
            "name": "课程帮",
            "code": null,
            "url": "https://www.kcbxgk.com/sso/cnuen/login?item=1",
            "userKey": null,
            "secretKey": null,
            "isCourseThird": 1,
            "showParams": null,
            "mark": 100,
            "markName": "中高考进阶学习",
            "coverUrl": null,
            "score": 5,
            "page": null,
            "limit": null,
            "canView": 1
          },
          {
            "id": 28,
            "name": "ddd",
            "code": null,
            "url": "ddd",
            "userKey": null,
            "secretKey": null,
            "isCourseThird": 0,
            "showParams": null,
            "mark": 100,
            "markName": "中高考进阶学习",
            "coverUrl": null,
            "score": 4,
            "page": null,
            "limit": null,
            "canView": 0
          }
        ]
      }
    },
    methods: {
      async getEvaluateList() {
        let resData = await Api.NewHome.getEvaluateList();
        if (JSON.stringify(resData.data) == '[]') return;
        let arr = Common.groupBy(resData.data, 'markName');
        this.list = [];
        arr.map(item => {
          let resources = [];
          item.map(each => {
            resources.push(each);
          })
          let obj = {
            title: item[0].markName,
            titleIcon: require("../assets/service/title-icon1.png"),
            resources: resources
          }
          this.list.push(obj);
        })
        for (let i = 0, length = this.list.length; i < length / 2; i++) {
          let temp = this.list[i]
          this.list[i] = this.list[length - 1 - i]
          this.list[length - 1 - i] = temp
        }
      },
      enter(item) {
        console.log('item---',item);
        console.log('this.$store:',this.$store.state)
        if (item.canView == 2) {
          this.$store.commit('isDisplayLogin', true);
          return;
        }
        Api.NewHome.getAuthKey({
          id: item.id
        }).then(resData => {
          console.log(resData);
          window.open(
            `${resData.data.url}&ticket=${resData.data.ticket}&platform=pc${!resData.data.paramString ? '':resData.data.paramString}`
            );
          // console.log(
          //   `${resData.data.url}&ticket=${resData.data.ticket}&platform=pc${!resData.data.paramString ? '':resData.data.paramString}`
          // );
        }).catch(err => {
          console.log(err);
        })
      },
    },
    mounted() {
      this.getEvaluateList();
    },
  }
</script>

<style scoped lang="less">
  .evaluation {
    background-color: #ffffff;
    .banner {
      width: 100%;
      display: block;
    }

    .resources-list {
      width: 1200px;
      margin: 50px auto 280px;
    }

    .list {
      border: 1px solid #F2F2F2;
      border-radius: 10px;
      margin-bottom: 50px;
      padding: 0 29px 0 28px;

      .list-title {
        border-bottom: 1px solid #f9f9f9;
        padding: 0 4px 0 33px;
        line-height: 73px;
        color: #383838;
        font-size: 20px;
      }

      .title-icon {
        vertical-align: middle;
        margin-right: 18px;
      }

      .more {
        color: #999;
        font-size: 16px;
      }

      .list-li {
        display: inline-block;
        box-sizing: border-box;
        width: calc(100% / 3);
        padding: 61px 0 69px 0;

        .list-li-wrapper {
          border-right: 1px solid #e9e9e9;
          padding: 0 47px 0 47px;
        }

        &:first-child .list-li-wrapper,
        &:nth-child(3n+1) .list-li-wrapper {
          padding-left: 22px;
        }

        &:nth-child(3n) .list-li-wrapper {
          padding-right: 18px;
          border-right: 0;
        }

        .list-li-info {
          width: 100%;
          margin-left: 25px;
        }

        .info-name {
          font-size: 22px;
          color: #383838;
          margin: 15px 0;
        }

        .enter {
          float: right;
          color: #749DFD;
          margin-top: 10px;
          margin-bottom: -10px;
        }
      }
    }

    /deep/ .el-rate__icon {
      margin-right: 3px;
    }

    @media screen and (max-width: 1250px) {
      .resources-list {
        width: 990px;
        margin: 41px auto 230px;
      }

      .list {
        margin-bottom: 41px;
        padding: 0 24px 0 23px;

        .list-title {
          line-height: 60px;
          font-size: 19px;
        }

        .more {
          font-size: 13px;
        }

        .list-li {
          padding: 50px 0 57px 0;

          .list-li-wrapper {
            padding: 0 38px;
          }

          &:first-child .list-li-wrapper,
          &:nth-child(3n+1) .list-li-wrapper {
            padding-left: 18px;
          }

          &:nth-child(3n) .list-li-wrapper {
            padding-right: 15px;
          }

          .list-li-info {
            margin-left: 23px;
          }

          .info-name {
            font-size: 23px;
          }
        }
      }
    }
  }
</style>7